module.exports = __webpack_public_path__ + "img/icon_pro_base_hk.b446690a.png";